import { FC, useState } from 'react'
import FaqCheckpointSelect from 'screens/Admin/KnowleageBase/components/FaqCheckpointsSelect'
import FaqProjectStageSelect from 'screens/Admin/KnowleageBase/components/FaqProjectStageSelect'
import FaqProjectTypeSelect from 'screens/Admin/KnowleageBase/components/FaqProjectTypeSelect'
import useFaqFiltersAndOptionsState from 'screens/KnowleageBase/hooks/useFaqFiltersAndOptionsState'
import TextField from 'shared/Forms/TextField'
import ModalHeader from 'shared/Modal/ModalHeader'
import Popover from 'shared/Modal/Popover'
import { ReactComponent as FilterIcon } from 'assets/icons/filter-icon.svg'
import IconButton from 'shared/Buttons/IconButton'
import FaqArticleSearch from 'screens/Admin/KnowleageBase/components/FaqArticleSearch'
import { ITreePluginsProps } from 'shared/Tree/tree.types'
import css from './knowleageBaseFilters.module.css'

type Props = ITreePluginsProps

const KnowleageBaseFilters: FC<Props> = (props) => {
  const {
    state: [state, handleChange],
    hasFilters,
    checkpointsOptions,
    projectStagesOptions,
    projectTypesOptions,
  } = useFaqFiltersAndOptionsState()

  const [filterAnchorEl, setFilterAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClickFilter = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (filterAnchorEl) {
      setFilterAnchorEl(null)
      return
    }
    setFilterAnchorEl(e.currentTarget)
  }

  const onCloseFilterPopover = () => {
    setFilterAnchorEl(null)
  }

  const open = Boolean(filterAnchorEl)
  return (
    <div>
      <div className='inline-flex-gap'>
        <FaqArticleSearch expandCtrl={props.expandCtrl} leafSelectCtrl={props.leafSelectCtrl} />
        <IconButton onClick={handleClickFilter} theme='grey-outline'>
          <div style={{ position: 'relative' }}>
            <FilterIcon />
            {hasFilters && <div className={css.hasFiltersDot}></div>}
          </div>
        </IconButton>
      </div>
      <Popover
        open={open}
        onClose={onCloseFilterPopover}
        anchorEl={filterAnchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <ModalHeader onClose={onCloseFilterPopover}>Фильтры</ModalHeader>
        <div className='modal-content'>
          <div className='flex-lines'>
            <TextField header='Тип проекта'>
              <FaqProjectTypeSelect
                options={projectTypesOptions}
                value={state.projectTypeId}
                name='projectTypeId'
                onChange={handleChange}
              />
            </TextField>
            <TextField header='"Этап'>
              <FaqProjectStageSelect
                options={projectStagesOptions}
                value={state.projectStageId}
                name='projectStageId'
                onChange={handleChange}
              />
            </TextField>
            <TextField header='Контрольные точки'>
              <FaqCheckpointSelect
                options={checkpointsOptions}
                value={state.checkpointIds}
                name='checkpointIds'
                onChange={handleChange}
              />
            </TextField>
          </div>
        </div>
        <div className='modal-footer'></div>
      </Popover>
    </div>
  )
}

export default KnowleageBaseFilters
